import type { IPlatformData } from '@wix/editor-elements-integrations';
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IMenuMapperProps,
  IMenuControllerProps,
  IMenuStateRefs,
} from '../Menu.types';

export const useComponentProps = ({
  mapperProps,
  stateValues,
}: IPlatformData<IMenuMapperProps, IMenuControllerProps, IMenuStateRefs>) => {
  const { currentUrl } = stateValues;

  return {
    ...mapperProps,
    currentUrl,
  };
};

export default withCompController(useComponentProps);
